export const CopyIcon = ({ size, className }: { size?: string; className?: string }) => (
  <svg
    width={size || "11"}
    height={size || "10"}
    viewBox="0 0 11 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path d="M1.83344 1.73771L1.83317 7.08333C1.83317 8.1879 2.77875 9.0917 3.97416 9.16224L4.12484 9.16667L8.17137 9.16725C7.98243 9.65244 7.47328 10 6.87484 10H3.6665C2.14772 10 0.916504 8.88071 0.916504 7.5V2.91667C0.916504 2.37232 1.29925 1.90924 1.83344 1.73771ZM8.70817 0C9.46756 0 10.0832 0.559644 10.0832 1.25V7.08333C10.0832 7.77369 9.46756 8.33333 8.70817 8.33333H4.12484C3.36545 8.33333 2.74984 7.77369 2.74984 7.08333V1.25C2.74984 0.559644 3.36545 0 4.12484 0H8.70817ZM8.70817 0.833333H4.12484C3.87171 0.833333 3.6665 1.01988 3.6665 1.25V7.08333C3.6665 7.31345 3.87171 7.5 4.12484 7.5H8.70817C8.9613 7.5 9.1665 7.31345 9.1665 7.08333V1.25C9.1665 1.01988 8.9613 0.833333 8.70817 0.833333Z" fill="black" fillOpacity="0.15"/>
  </svg>
);
